/* eslint-disable @typescript-eslint/no-unused-vars */
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, LinearProgress, MenuItem, Paper, Select, Snackbar, SnackbarCloseReason, Switch } from '@mui/material';
import { useState } from 'react';
import { AutoCompleteContaBancaria, AutoCompleteContaBancariaListagem, AutoCompleteParceiroListagem, AutoCompletePlanoDeContas01 } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RelatorioPagar from './Rpagar';
import { RelatorioFinanceiroService } from '../../../shared/services/api/Financeiro/relatorios/ServiceRelatorioFinanceiro';
import { NavBarRelatoriosFinanceiro } from '../../../shared/components/navbar/NavBarRelatoriosFinanceiro';

export const RelatoriosContasPagar: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [uidparceiro, setUidParceiros] = useState('');
  const [uidplanoconta, setUidplanoconta] = useState('');
  const [agrupar, setagrupar] = useState('sim');
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs());
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  const handleSave = () => {
    RelatorioFinanceiroService
      .Rpagar(uidparceiro, uidplanoconta, agrupar, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {

          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          if (result.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            RelatorioPagar(result as any, `Período: ${dayjs(dataInicial).format('DD/MM/YYYY')} a ${dayjs(dataFinal).format('DD/MM/YYYY')}`);
          } else {
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);
          }
        }
      });
  };
  const handleParceiros = (uuidparceiro: string | undefined) => {
    if (uuidparceiro != null) {
      setUidParceiros(uuidparceiro);
    } else {
      setUidParceiros('');
    }
  };
  const handleplanoconta = (uuidplanoconta: string | undefined) => {
    if (uuidplanoconta != null) {
      setUidplanoconta(uuidplanoconta);
    } else {
      setUidplanoconta('');
    }
  };

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1} alignContent='center'></Box>
      <Box
        component={Paper}
        sx={{
          width: '100%',
          maxWidth: 600,   // largura máxima
          margin: 'auto',
          padding: 1
        }}
      >
        <NavBarRelatoriosFinanceiro />
        <DialogTitle>Relatório de Contas a Pagar</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <Grid container padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompleteParceiroListagem
                  uuidparceiro={handleParceiros}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompletePlanoDeContas01
                  uuidplanoconta={handleplanoconta}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataInicial}
                    onChange={(newValue) => setDataInicial(newValue)}
                    label='Data Inicial'
                    slotProps={{
                      textField: {
                        size: 'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataFinal}
                    onChange={(newValue) => setDataFinal(newValue)}
                    label='Data Final'
                    slotProps={{
                      textField: {
                        size: 'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={agrupar === 'sim'}
                      onChange={(event) =>
                        setagrupar(event.target.checked ? 'sim' : 'nao')
                      }
                    />
                  }
                  label="Agrupar"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>

          <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};

